import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ModalSize } from "@signal/component-library/efx-modal";
import { BuscadorService } from 'src/app/services/shared/buscador/buscador.service';
import { FuenteDinamicaService } from 'src/app/services/shared/fuente-dinamica/fuente-dinamica.service';
import { GfdService } from 'src/app/services/shared/gfd/gfd.service';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';
import { forkJoin } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SignalDesignModule } from 'src/app/signal-design/signal-design.module';

@Component({
    selector: 'app-modal-search-for-matchkey',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, SignalDesignModule],
    templateUrl: './modal-search-for-matchkey.component.html',
    styleUrl: './modal-search-for-matchkey.component.scss'
})
export class ModalSearchForMatchkeyComponent implements OnChanges {
  @Input() showModal: boolean = false;
  @Output() modalClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() goToRouter: EventEmitter<any> = new EventEmitter<any>();
  form: FormGroup;
  modalSize = ModalSize;
  dataForm: Array<string> = [];
  inputDisabled = [];
  domain: string = "";
  subDomain: string = "";
  matchKey: Array<string> = [];
  typingTimeut: any;
  country: string = "";
  selectDomainAndSubdomain;
  entityKey:string = "";
  keyValues = [];
  options = [
    {
      id: "",
      description: "Seleccione una opción",
      disabled: false
    }
  ];
  // Nuevas propiedades para manejo de hash
  hashFieldsConfig: { [key: string]: boolean } = {};
  matchKeySeparator: string = ".";
  // Campos auto-llenados desde el buscador (ya vienen hasheados, no re-hashear)
  autoFilledFromBuscador: Set<string> = new Set();
  // Evita mostrar el contenedor del modal hasta tener datos listos de matchkey.
  isPreparingModal: boolean = false;
  fieldErrors: { [key: string]: string } = {};

  constructor(
    private formBuilder: FormBuilder,
    private fuenteDinamica: FuenteDinamicaService,
    private gfdService: GfdService,
    public localStorageService: LocalStorageService,
    private buscadorService: BuscadorService,
  ) {

  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("changes ModalSearchForMatchkeyComponent ---->", changes);
    if (changes['showModal'] && !changes['showModal'].firstChange) {
      if (this.showModal) {
        this.localStorageService.setMatchKeyData = null;
        this.dataForm = [];
        const dataMatchKey = this.localStorageService.getMatchKeyData;
        console.log("dataMatchKey ---->", dataMatchKey);

        // Verificar si hay un dominio pre-seleccionado
        const preSelectedDomain = this.localStorageService.getPreSelectedDomainForSearch;
        console.log('[ModalSearchForMatchkey] Pre-selected domain:', preSelectedDomain);

        if (preSelectedDomain) {
          this.isPreparingModal = true;
          // Si hay un dominio pre-seleccionado, cargar directamente sin mostrar dropdown
          this.handleGetMatchKey(preSelectedDomain);
        } else {
          this.isPreparingModal = false;
          // Si no hay pre-selección, generar lista de dropdown (comportamiento anterior)
          this.generateListDrop();
        }
      } else {
        this.isPreparingModal = false;
      }
    }
  }

  generateListDrop() {

    const menu = this.localStorageService.dataMenu;
    const noInclude = ["OBSERVACIONES_GKL", "Bureau", "BCRA","FINTECH_GKL","BOLAB RDS","BBRR RDS"];
    console.log("generateListDrop menu------>", menu)
    const options = [];
    menu.forEach(item => {

      if (!noInclude.includes(item.title)) {
        const values = {
          id: item.domaine ? item.domaine : `${item.domainJO}/${item.subDomainJO}`,
          description: item.title,
          disabled: false
        }

        options.push(values);
      }

    });

    options.unshift({
      id: "",
      description: "Seleccione una opción",
      disabled: false
    })
    this.options = options;

    console.log("generateListDrop options ------>", options);
  }
  initForm(data: Array<string>) {
    let struct: any = {}
    const dataPerson = this.localStorageService.getPersonaSelected;
    console.log("dataPerson ----->", dataPerson);

    this.keyValues = [];
    this.matchKey = data;

    // Determinar que campos se auto-llenan desde el buscador (valor ya hasheado)
    this.autoFilledFromBuscador = new Set<string>();
    data.forEach((matchKey: string, i: number) => {
      if (i === 0) {
        // Caso BOLAB: index 0 NO se auto-llena, offender_rut si
        if (this.domain === "CL_CREDIT" && this.subDomain === "DELINQUENCY_BOLAB") {
          this.autoFilledFromBuscador.add('offender_rut');
        } else {
          this.autoFilledFromBuscador.add(matchKey);
        }
      }
      if (matchKey === "entityKey" || matchKey === "nationalId") {
        this.autoFilledFromBuscador.add(matchKey);
      }
      if (this.country === 'CL') {
        const entitiesCL = ['rut', 'delinquent_debtor_rut', 'rol'];
        if (entitiesCL.includes(matchKey)) {
          this.autoFilledFromBuscador.add(matchKey);
        }
      }
    });
    console.log('[initForm] autoFilledFromBuscador:', [...this.autoFilledFromBuscador]);

    data.forEach((matchKey: string) => {
      const isAutoFilled = this.autoFilledFromBuscador.has(matchKey);
      const isHashEnabled = !isAutoFilled && (this.hashFieldsConfig[matchKey] || false);
      const entityKey = dataPerson.entityKey || dataPerson.hash || dataPerson.personaHash;
      console.log("entityKey ----->",entityKey);
      const initialFieldValue = matchKey === "entityKey" ? entityKey : '';
      // Primer campo: completamente editable
      struct[matchKey] = [initialFieldValue];
      this.entityKey = entityKey;

      if(matchKey === "nationalId"){
        const nationalId = dataPerson.entityKey || dataPerson['nationalIdHashed'];
        console.log("nationalId ----->",nationalId);
        this.entityKey = nationalId;
        struct[matchKey] = [nationalId];
      }

      if(this.country === 'CL'){
        const entitiesCL = ['rut','delinquent_debtor_rut','rol']
        if(entitiesCL.includes(matchKey)){
          const id = dataPerson["rut_sended_hash"] || dataPerson.entityKey;
          this.entityKey = id;
          struct[matchKey] = [id];
        }
      }
      const keyHash = `hash_${matchKey}`
      // Campos auto-llenados desde buscador: hash siempre false/disabled (ya vienen hasheados).
      // Resto: solo editable si viene en hashFields.
      struct[keyHash] = isHashEnabled
        ? [this.hashFieldsConfig[matchKey] || false]
        : [{ value: false, disabled: true }];
      console.log(`[initForm] Campo: ${matchKey}, AutoFilled: ${isAutoFilled}, Hash enabled: ${isHashEnabled}, Hash config: ${this.hashFieldsConfig[matchKey] || false}`);
      this.keyValues.push(keyHash);
    })
    this.form = this.formBuilder.group(struct);
    console.log("this.form ", this.form)
    this.dataForm = data;
    this.fieldErrors = {};
    this.applyCascadingEffect();
  }

  applyCascadingEffect() {
    // Todos los campos habilitados desde el inicio, sin lógica secuencial.
    this.dataForm.forEach((key: string, index: number) => {
      if (index === 0) {
        console.log("this.entityKey ---->", this.entityKey);
        if (this.domain === "CL_CREDIT" && this.subDomain === "DELINQUENCY_BOLAB") {
          this.form.get('offender_rut')?.setValue(this.entityKey);
        } else {
          this.form.get(key)?.setValue(this.entityKey);
        }
      } else {
        this.form.get(key)?.enable();
      }
    });
  }

  onKeyUp(event: any, index: number) {
    clearTimeout(this.typingTimeut);
    const value = event.target.value;

    this.typingTimeut = setTimeout(() => {
      console.log('usuario dejo de escribir event:', event);
      const newIndex = index + 1;
      if (newIndex <= this.inputDisabled.length && value !== "") {
        this.inputDisabled[newIndex] = false;
      }
      this.applyCascadingEffect();
      this.validateSequentialFields(this.form.getRawValue());
      console.log('usuario dejo de escribir:', value);
    }, 500)
  }

  private validateSequentialFields(values: any): boolean {
    this.fieldErrors = {};

    // Indice del ultimo campo con valor (primer campo es editable)
    let lastFilledIndex = 0;
    this.dataForm.forEach((key, i) => {
      if (i === 0) return;
      const v = values[key];
      if (v !== null && v !== undefined && `${v}`.trim() !== '') {
        lastFilledIndex = i;
      }
    });

    // Si hay valor en campo posterior, SOLO hash-fields anteriores son obligatorios.
    // No-hash puede quedar vacio (luego se completa con _NA_ en searchForMatchKey).
    let hasErrors = false;
    this.dataForm.forEach((key, i) => {
      if (i === 0 || i > lastFilledIndex) return;
      if (!this.hashFieldsConfig[key]) return;
      const v = values[key];
      if (v === null || v === undefined || `${v}`.trim() === '') {
        hasErrors = true;
        this.fieldErrors[key] = `Campo hash obligatorio: complete ${key} o borre campos posteriores.`;
      }
    });

    return !hasErrors;
  }

  searchForMatchKey() {
    const values = this.form.value;
    let values2 = this.form.getRawValue();

    // Defensa extra: primer campo de matchKey nunca se hashea.
    const firstMatchKeyField = this.matchKey?.[0];
    if (firstMatchKeyField) {
      values2[`hash_${firstMatchKeyField}`] = false;
    }


    const isSequenceValid = this.validateSequentialFields(values2);
    if (!isSequenceValid) {
      return;
    }

    // Hallar índice del último campo (excl. primero) con valor no vacío
    let lastFilledIndex = 0;
    this.dataForm.forEach((key, i) => {
      if (i === 0) return;
      const v = values2[key];
      if (v !== null && v !== undefined && `${v}`.trim() !== '') {
        lastFilledIndex = i;
      }
    });

    // Rellenar _NA_ SOLO para campos no-hash vacíos entre índice 1 y lastFilledIndex
    this.dataForm.forEach((key, i) => {
      if (i === 0 || i > lastFilledIndex) return;
      if (!this.hashFieldsConfig[key]) {
        const v = values2[key];
        if (v === null || v === undefined || `${v}`.trim() === '') {
          values2[key] = '_NA_';
        }
      }
    });

    console.log("values ---->", values)
    console.log("values2 ---->", values2)
    console.log("values searchForMatchKey ----->", values);
    const menu = this.localStorageService.dataMenu;
    console.log("menu searchForMatchKey ----->", menu);
    // const keys = Objectvalues2
    const searchFind = menu.find(itemMenu => itemMenu.domainJO === this.domain && itemMenu.subDomainJO === this.subDomain);
    console.log("searchForMatchKey searchFind----->", searchFind);
    if (searchFind) {
      let matchKey: string = "";

      matchKey = this.generateMatchKey(values2);


      console.log("searchForMatchKey matchKey---->", matchKey);
      const { route, domaine, domainJO, subDomainJO } = searchFind;

      const valuesArray = [];
      const keysArray = [];
      Object.entries(values2).forEach(([key, value]) => {
        if (key.startsWith("hash_") && value === true) {
          const relatedKey = key.replace("hash_", "");
          const relatedValue = values2[relatedKey];
          const hasValue = relatedValue !== null && relatedValue !== undefined && `${relatedValue}`.trim() !== '';

          // Solo hashear campos realmente informados por el usuario.
          if (!hasValue) {
            console.log(`[searchForMatchKey] Se ignora hash para ${relatedKey} por valor vacio`);
            return;
          }

          valuesArray.push({
            key: relatedKey,
            value: relatedValue
          });
          keysArray.push(relatedKey);
        }
      })
      const hashTrueValue = valuesArray.length > 0;

      let routeGo = "";
      if (domaine && domaine.includes('/')) {
        routeGo = domaine.toLowerCase();
      } else {
        const domainAndSubdomainNew = `${domainJO}/${subDomainJO}`;
        routeGo = domainAndSubdomainNew.toLowerCase();
        this.localStorageService.setDomainMatchKey = domainAndSubdomainNew;
      }
      console.log("route ------>", route);
      console.log("routeGo ------>", routeGo);
      console.log("hasTrueValue ------->", hashTrueValue);
      if (hashTrueValue) {
        console.log("hasTrueValue2 valuesArray------->", valuesArray);
        console.log("hasTrueValue2 keysArray------->", keysArray);

        const observables = valuesArray.map(match => this.buscadorService.getEncodeMkService(match.value));
        forkJoin(observables).subscribe({
          next: (response: any) => {
            let matchKey = "";
            console.log("forkJoin ----->", response);

            valuesArray.forEach((values, i: number) => {
              values2[values.key] = response[i].hash
            })

            matchKey = this.generateMatchKey(values2);

            this.localStorageService.setMatchKeyData = matchKey;
            this.localStorageService.setFullMatchKeyAdvanced = matchKey;

            this.loadConfigAndNavigate(routeGo);
          },
          error: (error: any) => {
            console.log("paso por aca error ---->", error);
            let matchKey = "";
            valuesArray.forEach((values, i: number) => {
              values2[values.key] = `.testHash${i}`
            })
            matchKey = this.generateMatchKey(values2);

            this.localStorageService.setMatchKeyData = matchKey;
            this.localStorageService.setFullMatchKeyAdvanced = matchKey;

            this.loadConfigAndNavigate(routeGo);
          }
        })
      } else {
        this.localStorageService.setMatchKeyData = matchKey;
        this.localStorageService.setFullMatchKeyAdvanced = matchKey;

        this.loadConfigAndNavigate(routeGo);
      }

    }

  }

  generateMatchKey(value) {
    // Arma la matchkey COMPLETA (todos los campos en orden de fields) unida por
    // el separador configurado. El modal setea getFullMatchKeyAdvanced con este
    // valor, y getIdHash lo consume tal cual sin preponer nada.
    const parts: string[] = [];
    this.matchKey.forEach((key) => {
      const raw = value[key];
      const normalized = raw !== null && raw !== undefined ? `${raw}`.trim() : "";
      if (normalized !== "") {
        parts.push(normalized);
      }
    });
    const matchKey = parts.join(this.matchKeySeparator);
    console.log("generateMatchKey resultado --->", matchKey);
    return matchKey;
  }

  didHide() {
    console.log("cierro modal", this.showModal);
    this.localStorageService.setMatchKeyData = null;
    this.localStorageService.setPreSelectedDomainForSearch = ''; // Limpiar pre-selección
    this.hashFieldsConfig = {}; // Limpiar configuración de hash
    this.autoFilledFromBuscador = new Set();
    this.fieldErrors = {};
    this.matchKeySeparator = ".";
    this.isPreparingModal = false;
    if (this.form) {
      const controls = Object.keys(this.form.controls);
      if(controls.length > 0){
        this.clearControls(controls);
      }
    }
    this.dataForm = []; // Resetear para próxima apertura
    this.modalClose.emit(false);
  }

  handleSelectDomain(event) {
    console.log("handleSelectDomain ----->", event);
    if(event !== ""){
      this.handleGetMatchKey(event);
    } else{
      console.log("handleSelectDomain paso sin ningun controls ----->", event);
      console.log("this.form.controls ------>",this.form.controls);
      const controls = Object.keys(this.form.controls);
      if(controls.length > 0){
        this.clearControls(controls);
      }
    }
  }


  clearControls(controls:Array<string>){
    console.log("clearControls ----->",controls);
    controls.forEach(control=>{
      this.form.removeControl(control);
    })

    this.form.updateValueAndValidity();
  }

  handleGetMatchKey(dataMatchKey) {

    const domainAndSubdomain = dataMatchKey.toUpperCase().split('/');
    console.log("domainAndSubdomain ---->", domainAndSubdomain);

    this.country = this.localStorageService.getRegionSeleccionada.getCode().toUpperCase() || "";
    this.domain = domainAndSubdomain[0];
    this.subDomain = domainAndSubdomain[1];

    this.fuenteDinamica.getMatchKey(this.country, domainAndSubdomain[0], domainAndSubdomain[1]).subscribe({
      next: (result: any) => {
        console.log('[handleGetMatchKey] result getMatchKey ---->', result);

        const fields: string[] = Array.isArray(result?.fields) ? result.fields : [];
        const hashFields: string[] = Array.isArray(result?.hashFields) ? result.hashFields : [];

        this.matchKeySeparator = typeof result?.separador === 'string' && result.separador.length > 0
          ? result.separador
          : ".";

        this.hashFieldsConfig = {};
        hashFields.forEach(fieldName => {
          this.hashFieldsConfig[fieldName] = true;
        });

        console.log('[handleGetMatchKey] hashFieldsConfig:', this.hashFieldsConfig);
        console.log('[handleGetMatchKey] separador:', this.matchKeySeparator);

        if (fields.length > 0) {
          this.initForm(fields);
        }
        this.isPreparingModal = false;
      },
      error: (error) => {
        console.error('[handleGetMatchKey] Error al obtener matchKey:', error);
        this.isPreparingModal = false;
      }
    });
  }

  private loadConfigAndNavigate(routeGo: string): void {
    const selectedConfig = this.localStorageService.getSelectedGfdConfig || 'Default';
    console.log('[loadConfigAndNavigate] Cargando configs para', this.domain, this.subDomain, 'config:', selectedConfig);

    forkJoin({
      configs: this.gfdService.getGfdConfigs(this.domain, this.subDomain),
      gfd: this.fuenteDinamica.getEstructuraDinamica(this.domain, this.subDomain, selectedConfig)
    }).subscribe({
      next: ({ configs, gfd }) => {
        console.log('[loadConfigAndNavigate] configs obtenidas:', configs);
        console.log('[loadConfigAndNavigate] gfd obtenido:', gfd);

        if (gfd?.header?.[0]) {
          this.localStorageService.setEstructuraDinamicaHeader = gfd.header[0];
        }

        if (Array.isArray(gfd?.fields)) {
          this.localStorageService.setEstructuraDinamicaField = gfd.fields;
        }

        this.goToRouter.emit(routeGo);
      },
      error: (error) => {
        console.error('[loadConfigAndNavigate] Error al cargar configs, navegando de todas formas:', error);
        this.goToRouter.emit(routeGo);
      }
    });
  }

}
